class AddressesPage {
  constructor() {
    document.querySelectorAll('.form-wrap > form')
      .forEach(form => {
        const countrySelector = form.querySelector('[name="address[country]"]').id;
        const provinceSelector = form.querySelector('[name="address[province]"]').id;
        const containerSelector = form.querySelector('.province-wrap').id;

        new window.Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
          hideElement: containerSelector
        });
      });

    document.querySelectorAll('.address-edit-link')
      .forEach(
        elem => elem.addEventListener('click', this.handleEditClick)
      );

    document.querySelectorAll('.address-delete-link')
      .forEach(elem => elem.addEventListener(
        'click',
        this.handleDeleteClick
      ));
  }

  handleEditClick = (e) => {
    e.preventDefault();
    const formId = e.currentTarget.getAttribute('data-form-id');
    this.activateEdit(formId);
  };

  handleDeleteClick = (e) => {
    e.preventDefault();
    const addressUrl = e.currentTarget.getAttribute('data-address-url');

    if (
      confirm('Are you sure you wish to delete this address?')
    ) {
      Shopify.postLink(addressUrl, {
        parameters: { _method: 'delete' }
      });
    }
  };

  activateEdit(formId) {
    document.querySelector('.address-list').style.display = 'none';
    document.querySelector('button[data-form-id="new"]').style.display = 'none';
    document.querySelector(`.form-wrap[data-form="${formId}"]`).style.display = 'block';
    document.querySelector('.general-link.go-back').style.display = 'block';
  }
}


export default () => {
  new AddressesPage();
};
